// extracted by mini-css-extract-plugin
module.exports = {"container":"e_8g","hasBadge":"e_9g","bottomLine":"e_-g","imageContainer":"e_ah","image":"e_bh","header":"e_ch","title":"e_dh","score":"e_eh"};